import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.sass'],
})
export class SelectComponent implements OnInit {
  @Input()
  config: IFieldConfig;

  @Input()
  useCompare: boolean = true;

  @Input()
  isMultipleSelect: boolean = false;

  @Input()
  compareFn: (o1: any, o2: any) => boolean = (o1: any, o2: any) => {
    if (o1?.id && o2?.id) return o1?.id === o2?.id;
    else return o1 === o2;
  };

  @Input()
  group: FormGroup;

  @Input()
  value: string;

  @Output()
  onSelect: EventEmitter<any> = new EventEmitter();

  @Input()
  typeCes?: TypeCesEnum | undefined;

  constructor() {}

  ngOnInit(): void {}

  getOptions() {
    return this.config?.options?.map((it) =>
      this.value ? it[this.value] : it
    );
  }

  onChange(event: any) {
    if (!(event.value instanceof Object)) {
      this.onSelect.emit(event.value);
      return;
    }

    let object = this.config?.options?.find(
      (it: any) => it[this.value] === event.value
    );
    this.onSelect.emit(object);
  }

  getValue() {
    return this.group.get(this.config.name)?.getRawValue();
  }
}
